// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/EnterpriseAdminNavigation.jsx

import React from "react";

const NAV_ITEMS = [
  { key: "overview", label: "Overview", description: "Administrative health" },
  { key: "organization", label: "Organization", description: "Profile and launch context" },
  { key: "commercial", label: "Commercial", description: "Agreement and pricing authority", requiredPermission: "commercial.read" },
  { key: "users", label: "Users", description: "People and invitations" },
  { key: "roles", label: "Roles & Permissions", description: "Authority model" },
  { key: "connectors", label: "Connectors", description: "Connection operations" },
  { key: "preferences", label: "Preferences", description: "Operating defaults" },
  { key: "audit", label: "Audit", description: "Governance traceability" },
  { key: "lifecycle", label: "Retention & Offboarding", description: "Data lifecycle controls" },
];

export default function EnterpriseAdminNavigation({
  activeSection,
  onSectionChange,
  onChange,
  permissions = [],
}) {
  const handleChange = onSectionChange || onChange;
  const permissionSet = new Set(Array.isArray(permissions) ? permissions : []);
  const visibleItems = NAV_ITEMS.filter(
    (item) => !item.requiredPermission || permissionSet.has(item.requiredPermission)
  );

  return (
    <aside className="enterprise-admin-nav" aria-label="Enterprise administration sections">
      <div className="enterprise-admin-nav-title">
        <strong>Administration</strong>
        <span>Control plane</span>
      </div>
      <div className="enterprise-admin-nav-list">
        {visibleItems.map((item) => (
          <button
            key={item.key}
            type="button"
            className={activeSection === item.key ? "active" : ""}
            onClick={() => handleChange(item.key)}
            aria-current={activeSection === item.key ? "page" : undefined}
          >
            <strong>{item.label}</strong>
            <span>{item.description}</span>
          </button>
        ))}
      </div>
    </aside>
  );
}
